import React, { useRef } from 'react';
import { CSSTransition } from 'react-transition-group';

const TIMEOUT = { enter: 220, exit: 170 };

// Abre/fecha altura+fade. Condicional: <JdsCollapse in={cond}>…</JdsCollapse>.
// Lista: <TransitionGroup>{items.map(i => <JdsCollapse key={i.id}>…</JdsCollapse>)}</TransitionGroup>
// (o TransitionGroup injeta `in`; itens já presentes no mount não animam).
// `className` vai no wrapper (ex.: col-lg-3 dentro de .row). Enquanto sai, mantém o
// último conteúdo visto com `in` verdadeiro: o texto não some antes da altura fechar.
export function JdsCollapse({ children, className = '', ...props }) {
  const last = useRef(children);
  if (props.in) last.current = children;

  return (
    <CSSTransition
      timeout={TIMEOUT}
      classNames="jds-collapse"
      unmountOnExit
      {...props}
    >
      <div className={`jds-collapse ${className}`.trim()}>
        <div className="jds-collapse__inner">{last.current}</div>
      </div>
    </CSSTransition>
  );
}
